<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue';
import { useListaRevendaStore } from '@/stores/listaRevendas';

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  endereco: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['close', 'success', 'update:show']);

const listaRevendasStore = useListaRevendaStore();

const loadingCadastro = ref(false);
const cadastroSuccess = ref(false);
const cadastroError = ref('');

const formData = ref({
  rua: '',
  numero: '',
  bairro: '',
  cidade: '',
  estado: '',
  cep: '',
  obs: '',
  achou_caro: false
});

watch(() => props.endereco, (novoEndereco) => {
  if (novoEndereco) {
    formData.value = {
      rua: novoEndereco.logradouro || '',
      numero: novoEndereco.numero || '',
      bairro: novoEndereco.bairro || '',
      cidade: novoEndereco.cidade || '',
      estado: novoEndereco.estado || '',
      cep: novoEndereco.cep || '',
      obs: '',
      achou_caro: false
    };
  }
}, { immediate: true, deep: true });

// Fechar o modal
const fecharModal = () => {
  emit('update:show', false); // Emit event to update the show prop
  emit('close');
  resetarForm();
};

// Resetar o formulário
const resetarForm = () => {
  cadastroSuccess.value = false;
  cadastroError.value = '';
  formData.value.obs = '';
  formData.value.achou_caro = false;
};

// Cadastrar endereço sem revendedor
const cadastrar = async () => {
  loadingCadastro.value = true;
  cadastroError.value = '';
  cadastroSuccess.value = false;
  
  try {
    const result = await listaRevendasStore.cadastrarEnderecoSemRevendedor(formData.value);
    
    if (result.success) {
      cadastroSuccess.value = true;
      
      // Emitir evento de sucesso
      emit('success');
      
      // Fechar modal após 2 segundos
      setTimeout(() => {
        fecharModal();
      }, 2000);
    } else {
      cadastroError.value = result.error || 'Erro ao cadastrar endereço';
    }
  } catch (error) {
    console.error('Erro ao cadastrar endereço sem revendedor:', error);
    cadastroError.value = 'Ocorreu um erro ao cadastrar o endereço. Tente novamente.';
  } finally {
    loadingCadastro.value = false;
  }
};
</script>

<template>
  <v-dialog 
    :model-value="show" 
    @update:model-value="(val) => emit('update:show', val)"
    max-width="500"
  >
    <v-card>
      <v-card-title class="text-h5 bg-primary text-white">
        Cadastrar endereço sem revendedor
      </v-card-title>
      
      <v-card-text class="pa-4 pt-2">
        <v-alert
          v-if="cadastroError"
          type="error"
          variant="tonal"
          closable
          class="mb-4"
        >
          {{ cadastroError }}
        </v-alert>
        
        <v-alert
          v-if="cadastroSuccess"
          type="success"
          variant="tonal"
          class="mb-4"
        >
          Endereço cadastrado com sucesso!
        </v-alert>
        
        <v-form @submit.prevent="cadastrar">
          <v-checkbox
            v-model="formData.achou_caro"
            label="Achou caro?"
            color="primary"
            hide-details
            class="mb-4"
          ></v-checkbox>
          
          <v-textarea
            v-model="formData.obs"
            label="Observações"
            variant="outlined"
            auto-grow
            rows="3"
            placeholder="Digite aqui qualquer informação adicional sobre este endereço"
          ></v-textarea>
          
          <div class="d-flex justify-end mt-4">
            <v-btn 
              variant="text" 
              @click="fecharModal" 
              class="me-2"
              :disabled="loadingCadastro"
            >
              Cancelar
            </v-btn>
            <v-btn 
              color="primary" 
              type="submit"
              :loading="loadingCadastro"
            >
              Cadastrar
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
